import { render } from "./ChristmasOfferHome.vue?vue&type=template&id=249691c2&scoped=true"
import script from "./ChristmasOfferHome.vue?vue&type=script&lang=js"
export * from "./ChristmasOfferHome.vue?vue&type=script&lang=js"

import "./ChristmasOfferHome.vue?vue&type=style&index=0&id=249691c2&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-249691c2"],['__file',"src/views/pre/ChristmasOfferHome.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "249691c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('249691c2', __exports__)) {
    console.log('reload')
    api.reload('249691c2', __exports__)
  }
  
  module.hot.accept("./ChristmasOfferHome.vue?vue&type=template&id=249691c2&scoped=true", () => {
    console.log('re-render')
    api.rerender('249691c2', render)
  })

}


export default __exports__